export default class ProgressScroll {
  constructor() {
    this.progressBar = document.querySelector(".js-progress-scroll");

    this.setProgress = this.setProgress.bind(this);
  }

  init() {
    this.events();
  }

  events() {
    window.addEventListener("scroll", this.setProgress);
  }

  setProgress() {
    var h = document.documentElement,
      b = document.body,
      st = "scrollTop",
      sh = "scrollHeight",
      scroll;

    scroll = ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;

    this.progressBar.style.setProperty("--scroll", scroll + "%");
  }
}



// WEBPACK FOOTER //
// ./scripts/components/progressScroll.js